// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__3jCBI","viewContainer":"styles_viewContainer__1Gsjo","zoom":"styles_zoom__B-9DW","noContent":"styles_noContent__1mtAx"};